import { render, staticRenderFns } from "./OrderDetailsFields.vue?vue&type=template&id=6bad3706"
import script from "./OrderDetailsFields.vue?vue&type=script&lang=js"
export * from "./OrderDetailsFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports